<template>
  <PageLayoutWrapper
    page="departments/_id/programs"
    :props="{...$props, programs: programsNormalized }"
  >
    <div class="page-content">
      <BaseTable
        :rows="programsNormalized"
        resource-name="Programs"
        @select="goToProgram"
      >
        <template #header>
          <th class="th">Name</th>
          <th class="th">Degree Designation</th>
          <th class="th">Description</th>
        </template>
        <template #default="{ row: program }">
          <td>
            <NuxtLink
              :to="getProgramUrl(program)"
              :aria-label="programNameWithFallbacks(program)"
              :name="programNameWithFallbacks(program)"
            >
              {{ programNameWithFallbacks(program) }}
            </NuxtLink>
          </td>
          <td>
            {{ getDegreeDesignations(program) }}
          </td>
          <td>
            {{ getShortDescription(program.description || program.catalogDescription) }}
          </td>
        </template>
      </BaseTable>
    </div>
  </PageLayoutWrapper>
</template>

<script>
import _sortBy from 'lodash/sortBy'
import { getShortDescription, safeEncodeURIComponent } from '@/utils/generalUtils'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import ProgramsService from '@/services/programs'
import usePrograms from '@/composables/usePrograms'
import { programNameWithFallbacks } from '@/utils/entityNames'
import { departmentRelatedProgramsFields } from '@/constants/departments'
import useMeta from '@/composables/useMeta'

export default {
  components: { PageLayoutWrapper },
  props: {
    department: {
      type: Object,
      required: true,
    },
    programs: {
      type: Array,
      required: false,
      default: () => [],
    },
    availableColumns: {
      type: Array,
      default: () => [
        {
          id: 'Name',
        },
        {
          id: 'Degree Designation',
        },
        {
          id: 'Description',
        },
      ],
    },
  },
  setup(props, { root }) {
    const { goToProgram, getProgramUrl } = usePrograms(root)
    const { catalogWideMetaTitle } = useMeta()
    return {
      getProgramUrl,
      goToProgram,
      programNameWithFallbacks,
      catalogWideMetaTitle,
    }
  },
  async asyncData({ params, $bugsnag, $axios, redirect, store }) {
    const api = new ProgramsService($axios, store)

    try {
      const { data } = await api.getPrograms({
        department: safeEncodeURIComponent(params.id),
        columns: departmentRelatedProgramsFields,
      })
      let programs = data

      programs = _sortBy(Object.values(programs), [
        'code',
        'name',
        'longName',
        'transcriptDescription',
      ])

      return { programsFallback: programs }
    } catch (e) {
      $bugsnag.notify(e)
      redirect('/404')
    }
  },
  head() {
    return {
      title: `${this.department.displayName} Department Program | ${
        this.catalogWideMetaTitle
      }`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `${this.department.displayName} Department Program | ${
            this.catalogWideMetaTitle
          }`,
        },
      ],
    }
  },
  computed: {
    programsNormalized() {
      if (this.programs?.length) return this.programs
      return this.programsFallback || []
    },
  },
  methods: {
    getShortDescription,
    getDegreeDesignations(program) {
      if (program.degreeDesignation) return program.degreeDesignation
      if (program.degreeDesignations && program.degreeDesignations.length > 0) {
        return program.degreeDesignations.join(', ')
      }
      return ''
    },
  },
}
</script>
